export default __webpack_public_path__ + "static/4-ba77f17ea1981584f0b432c6cd188fcf.png";